<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form"
    @submit.prevent="onSubmit"
  >
    <h5 class="text--center text-h5 font-weight-regular">
      Clique em continuar para iniciar o processo de Renovação Cadastro Transportadora
    </h5>

    <v-card-actions class="mt-2 mr-0 ml-0 pt-0">
      <v-spacer />
      <v-btn
        depressed
        type="submit"
        color="primary"
        class="mt-1"
      >
        Continuar
      </v-btn>
      <v-spacer />
    </v-card-actions>
    <section
      v-if="form.isLoading"
      class="loading"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <span>Enviando informações ...</span>
    </section>
  </v-form>
</template>

<script>
import VeiculoTransportadoraService from "@/services/sit-pedidos/veiculo-transportadora.service";

// Vuex Store - Sit Pedidos (mapping actions and states)
import { mapState, mapActions, mapMutations } from "vuex";
import pedidoService from '@/services/sit-pedidos/pedido.service';
const actions = mapActions('sitPedidos', ['setFormPedido', 'setFormIsLoading', 'setFormStep'])
const state = mapState('sitPedidos', ['form'])

export default {
  name: "RenovationCompanyForm",
  data: () => ({
    isLoadingSearch: false,
    search: null,
    items: [],
    formCreate: {
      tipoPedido: "RENOVACAO_CADASTRO_TRANSPORTADORA", // Renovação do Registro de Transportadora
    },
    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    }
  }),
  computed: {
    ...state
  },
  watch: {
    search(val) {
      this.loadVeiculos(val);
    }
  },
  mounted() {
    this.loadVeiculos();
  },
  methods: {
    ...actions,
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        const {
          tipoPedido,
        } = this.formCreate;
        this.setFormIsLoading(true)

        // TODO: remover essa dependencia de setar qual tipo de serviço e tratar no backend
        const tipoServicos = { id: 3 }

        pedidoService.createPedidoCompany({ tipoPedido, tipoServicos }).subscribe((res)=>{
          this.setFormIsLoading(false)
          this.setFormPedido(res)
          this.setFormStep(2)
        }, (err)=>{
          this.setFormIsLoading(false)
        })
      }
    },
    loadVeiculos(value = "") {
      if (this.items.length > 0) return;

      if (this.isLoadingSearch) return;

      this.isLoadingSearch = true;

      const query = {
        page: 0,
        size: 10000
      };

      VeiculoTransportadoraService.listExcludes(query).subscribe(
        ({ content }) => {
          this.items = content;
          this.isLoadingSearch = false;
        },
        err => {
          this.isLoadingSearch = false;
        }
      );
    },
  },
};
</script>

